import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";
import AppLayout from "./AppLayout";

// Member funnel guard: routes members through profile setup -> welcome tour -> app.
// Admins skip the funnel entirely (role-based onboarding).
export default function MemberGuard() {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="animate-spin text-primary" size={32} strokeWidth={1.5} />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <AppLayout />;
  const gated = user.security_v2;
  if (gated && !user.email_verified) return <Navigate to="/verify-email-required" replace />;
  if (!user.onboarded) return <Navigate to="/onboarding" replace />;
  if (gated && !user.phone_verified) return <Navigate to="/verify-phone" replace />;
  if (!user.welcome_seen) return <Navigate to="/welcome" replace />;
  return <AppLayout />;
}
